import loadable from '@loadable/component';

const CampaignDealsLoader = loadable(
  () => import(/* webpackChunkName: "secondary-content" */ './campaign-deals')
);

export default CampaignDealsLoader;
